module.exports = __webpack_public_path__ + "static/media/sliders-h-solid.cf946409.svg";